export enum MetadataTabActionType {
  SET_REVIEW_BLOCKED_BY_ERRORS = 'METADATA_TAB_SET_REVIEW_BLOCKED_BY_ERRORS',
}

export interface MetadataTabSetReviewBlockedByErrorsAction {
  type: MetadataTabActionType.SET_REVIEW_BLOCKED_BY_ERRORS;
  fileId: string;
  reviewBlockedByErrors: boolean;
}

export function setReviewBlockedByErrors(
  fileId: string,
  reviewBlockedByErrors: boolean
): MetadataTabSetReviewBlockedByErrorsAction {
  return {
    type: MetadataTabActionType.SET_REVIEW_BLOCKED_BY_ERRORS,
    fileId,
    reviewBlockedByErrors,
  };
}

export type MetadataTabAction = MetadataTabSetReviewBlockedByErrorsAction;
